const Φ = (1 + Math.sqrt(5)) / 2;

function colourBank(n = 10) {
	const count = [];
	for (let i = 0; i < n; ++i) count[i] = 0;
	return {
		use(colour) {
			if (!colour.startsWith("r")) return;
			++count[parseInt(colour.substring(1), 10)];
		},
		next() {
			const nextColour = count.indexOf(Math.min(...count));
			++count[nextColour];
			return `r${nextColour}`;
		}
	};
}

export default function ribbonColourer() {
	let lastRibbons;
	return (ribbons, puzzleBeads) => {
		const { use, next } = colourBank();
		const uncolouredRibbons = new Set(ribbons);

		// colour any completed ribbons their bead colour
		for (const r of uncolouredRibbons) {
			const { complete, colour } = r.isComplete(puzzleBeads);
			if (!complete) continue;
			r.setClass(`p${colour + 1}`);
			uncolouredRibbons.delete(r);
		}

		// find the most overlapping ribbons and carry forward their colours
		if (lastRibbons) for (const l of lastRibbons
			.filter(r => !r.isComplete(puzzleBeads).complete)
			.sort((a, b) => b.size - a.size)
		) {
			const mostSimilar = l.mostSimilar(uncolouredRibbons);
			if (!mostSimilar) continue;
			const { colour } = mostSimilar.isComplete(puzzleBeads);
			const [className] = l.classes;
			if (colour) mostSimilar.setClass(className, `i${colour + 1}`);
			else mostSimilar.setClass(className);
			use(className);
			uncolouredRibbons.delete(mostSimilar);
		}

		for (const ribbon of uncolouredRibbons) {
			const { colour } = ribbon.isComplete(puzzleBeads);
			if (colour) ribbon.setClass(next(), `i${colour + 1}`);
			else ribbon.setClass(next());
		}
		lastRibbons = ribbons;
	};
}
